<template>
  <ul class="timeline" :style="cssVariables">
    <li v-for="(item, i) in sortedItems" v-bind:key="i">
      <span></span>
      <h6>{{ item.title }}</h6>
      <slot name="description" v-bind:item="item"></slot>
      <div class="timeline__date">
        <span>{{ item.end || 'Current' }}</span>
        <span>{{ item.start }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    source: {
      type: Array,
      required: true
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    stackColor: {
      type: String,
      default: '#ffffff'
    },
    bulletColor: {
      type: String,
      default: 'transparent'
    }
  },

  data () {
    return {
    }
  },

  computed: {
    cssVariables () {
      return {
        '--font-color': this.textColor,
        '--stack-color': this.stackColor,
        '--bullet-color': this.bulletColor
      }
    },

    sortedItems () {
      return this.source.slice(0).sort((a, b) => (b.end || 0) - (a.end || 0))
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin clearfix {
  content: '';
  position: absolute;
  top: 0; left: 0;
}
@mixin set-border($thickness, $color, $radius) {
  border: $thickness solid $color;
  border-radius: $radius;
}

.timeline {
  position: relative;
  color: var(--font-color);

  &::before {
    @include clearfix();
    height: 100%;
  }

  li {
    position: relative;
    margin: 4rem 3.5rem;
    list-style: none;
    line-height: 2rem;

    & > span {
      @include clearfix();
      left: -2rem;
      height: 110%;
      @include set-border(2px, var(--stack-color), none);
    }

    & > span::before,
    & > span::after {
      @include clearfix();
      width: 1rem;
      height: 1rem;
      @include set-border(3px, var(--stack-color), 50%);
      background-color: var(--bullet-color);
      left: -0.5rem;
    }

    & > span::before {
      top: -1rem;
    }

    & > span::after {
      top: 100%;
    }

    h6 {
      font-size: 1.2rem;
    }
  }

  &__date span {
    position: absolute;
    font-size: 1.125rem;
    left: -7rem;
    width: 4rem;
    text-align: right;
    &:first-child {
      top: -20px;
    }
    &:last-child {
      top: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue